import BusyIndicator from "@components/busyIndicator";
import { getInfoValue } from "@components/smart/FieldInfo";
import BindingContext, { createBindingContext } from "@odata/BindingContext";
import { IPrAttendanceEntity, IPrPayslipEmploymentEntity, } from "@odata/GeneratedEntityTypes";
import { getDefinitions } from "@pages/payroll/attendance/Attendance.def";
import AttendanceFormView, { IAttendanceCustomData } from "@pages/payroll/attendance/AttendanceFormView";
import { cloneDeep } from "lodash";
import React, { useCallback, useEffect, useRef, useState } from "react";

import { FormStorage, IFormModel } from "../../../../views/formView/FormStorage";
import { FormViewForExtend } from "../../../../views/formView/FormView";


interface IProps {
    rootStorage: FormStorage; // needed as a template and common context
    employmentBindingContext?: BindingContext;
    onClose?: () => void;
    onAttendanceChange?: () => void;
}

type TAttendanceStorage = FormStorage<IPrAttendanceEntity, IAttendanceCustomData>

export async function createAttendanceStorage(parentStorage: FormStorage, args: Partial<IFormModel>): Promise<TAttendanceStorage> {
    // use clone in form storage - we can edit the form storage definition but still keep original values
    const definition = cloneDeep(getDefinitions(parentStorage.context));
    delete definition.table;

    // definition.form.groups.forEach(grp => {
    //
    // });

    const { oData, t, history, match, theme, context } = parentStorage;
    const { bindingContext: _, ...passArgs } = args;

    const storage = new FormStorage({
        oData, t, history, match, theme, context,
        id: definition.form.id,
        definition: definition.form,
        ...passArgs
    }) as TAttendanceStorage;

    const employmentEntity = parentStorage.getValue(args.bindingContext) as IPrPayslipEmploymentEntity;

    const bindingContext = createBindingContext(getInfoValue(definition, "entitySet"), oData.getMetadata())
            .addKey(employmentEntity?.Attendance?.Id);

    storage.init({
        ignoreVariants: true,
        bindingContext
    });

    return storage;
}

export function AttendanceFormPage({ rootStorage, employmentBindingContext, onClose, onAttendanceChange }: IProps): React.ReactElement {

    const _formRef = useRef<FormViewForExtend<IPrAttendanceEntity>>();
    const [storage, setStorage] = useState<TAttendanceStorage>(null);

    useEffect(() => {
        createAttendanceStorage(rootStorage, {
            refresh: () => {
                _formRef.current?.forceUpdate();
            },
            bindingContext: employmentBindingContext
        }).then(setStorage);
    }, []);

    const handleAfterSave = useCallback(() => {
        onAttendanceChange?.();
    }, [onAttendanceChange]);

    if (!storage) {
        return (<BusyIndicator />);
    }

    return (
        <AttendanceFormView ref={_formRef}
                            storage={storage}
                // onBeforeSave={handleBeforeSave}
                // onSaveFail={handleSaveFail}
                            onAfterSave={handleAfterSave}
                            onCancel={onClose}
                            formProps={{
                                hideBreadcrumbs: true,
                                shouldHideVariant: true,
                                shouldHideAuditTrail: true,
                            }}
                            // do not use "isInDialog" as it turns off busy indicator on save (or solve it another way)
        />
    );
}